import type { ServerResponse } from 'http';

function getDaysRemaining(date: number): string | null {
  // Set the date we're counting down to
  const countDownDate = new Date(date).getTime();

  // Update the count down every 1 second
  // Get today's date and time
  const now = new Date().getTime();
  // Find the distance between now and the count down date
  const distance = countDownDate - now;
  // Time calculations for days, hours, minutes and seconds
  const days = Math.floor(distance / (1000 * 60 * 60 * 24));

  if (days <= 14) {
    if (days > 2) {
      return `${days} days`;
    }
    if (days > 1) {
      return `tomorrow`;
    }
    if (days === 0) {
      return `today`;
    }
  }

  return null;
}

function getEncoreColor(name?: string) {
  switch (name) {
    case 'premium':
      return '#FFD2D7';
    case 'premiumDuo':
      return '#FFC862';
    case 'premiumStudent':
      return '#C4B1D4';
    case 'premiumFamily':
      return '#A5BBD1';
    case 'premiumMini':
      return '#CFF56A';
    default:
      return '#BBB';
  }
}

function ensureSuccessApiResponseStatus<T>(
  request: PromiseSettledResult<T>,
  res: ServerResponse,
) {
  if (request.status === 'rejected') {
    res.statusCode = 500;
    throw request.reason;
  }
  return request.value;
}

export { getDaysRemaining, getEncoreColor, ensureSuccessApiResponseStatus };
